import type { FC, ReactElement } from "react"

import { Typography } from "@/3514/components/shared/typography/typography.component"
import {
    ETypographyColor,
    ETypographyFamily,
    ETypographySize,
    ETypographyTag,
    ETypographyWeight
} from "@/3514/components/shared/typography/typography.types"
import { buildCssClassName } from "@/3514/utils"
import { type IUseTranslation, useTranslation } from "@/hooks"

import { liveMarkAssets as assets } from "./live-mark.assets"

type _TProps = { isVisible: boolean; isIconOnly?: boolean }

const classes = {
    container: ({ isIconOnly }: { isIconOnly: boolean }): string =>
        buildCssClassName("flex gap-x-[8px] items-center w-fit", {
            "mx-auto": !isIconOnly
        }),
    icon: (): string => "animate-joinSession",
    label: (): string => "min-w-fit"
}

const LiveMark: FC<_TProps> = ({ isVisible, isIconOnly = false }: _TProps): ReactElement => {
    const { t }: IUseTranslation = useTranslation()

    return isVisible ? (
        <div className={classes.container({ isIconOnly })} aria-live="polite" aria-label="Live Session">
            <div className={classes.icon()}>
                <assets.Icon />
            </div>

            {isIconOnly || (
                <Typography
                    text={t("common.liveNow")}
                    tag={ETypographyTag.Heading3}
                    size={ETypographySize.Medium}
                    color={ETypographyColor.Accent}
                    weight={ETypographyWeight.Medium}
                    family={ETypographyFamily.DmSerif}
                    className={classes.label()}
                />
            )}
        </div>
    ) : null
}

LiveMark.displayName = "LiveMark"

export { LiveMark }
